import { cx } from "@emotion/css";
import { ReactNode } from "react";

import { ButtonLoader } from "@/modules/theme/components/Loader/ButtonLoader";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { createButtonStyles } from "@/modules/theme/utils/createButtonStyles";
import { ButtonVariants } from "@/modules/theme/utils/types";

export type ButtonProps = {
  className?: string;
  isDisabled?: boolean;
  children: ReactNode;
  isLoading?: boolean;
  variant?: ButtonVariants;
  withShadow?: boolean;
} & ReactButtonProps;

export function Button({
  children,
  className,
  type = "button",
  variant = "primary",
  isLoading,
  isDisabled,
  withShadow = false,
  ...props
}: ButtonProps) {
  const theme = useTheme();
  const classes = createButtonStyles(theme);
  return (
    <button
      disabled={isLoading || isDisabled}
      className={cx(
        classes.root,
        classes[variant],
        { [classes.disabled]: isDisabled },
        { [classes.loading]: isLoading },
        { [classes.withShadow]: withShadow },
        className
      )}
      type={type}
      {...props}
    >
      {isLoading && <ButtonLoader variant={isDisabled ? "neutral" : variant} />}
      {children}
    </button>
  );
}

type ReactButtonProps = React.ComponentProps<"button">;
